import React from "react"
import { useSelector } from "react-redux"
import { noReports } from "reduxSlices/reportIndexSlice"

const ReportsEmptyState = () => {
  const organizationHasNoReports = useSelector(noReports)

  return (
    <div className="flex flex-col w-full items-center pt-16">
      <span>
        {
          organizationHasNoReports
            ? "There are no reports for you right now."
            : "No reports match the filters you have selected."
        }
      </span>
    </div>
  )
}

export default ReportsEmptyState
